// @flow
import * as React from 'react';
import { selectedCategoryIdContext } from 'routes/RouteProvider';

type InjectedProps = {|
  +selectedCategoryId: string | null,
|};

function withSelectedCategoryId<OwnProps>(
  WrappedComponent: React.AbstractComponent<{|
    ...OwnProps,
    ...InjectedProps,
  |}>
): React.AbstractComponent<OwnProps> {
  function WithselectedCategoryId(props) {
    return (
      <selectedCategoryIdContext.Consumer>
        {(selectedCategoryId) => (
          <WrappedComponent
            selectedCategoryId={selectedCategoryId}
            {...props}
          />
        )}
      </selectedCategoryIdContext.Consumer>
    );
  }
  return WithselectedCategoryId;
}

export default withSelectedCategoryId;
